import {onFind} from "@elements/init-modules-in-scope";
import {getPrefixedDataSet} from "@elements/data-set-utils";

export function init () {
    const isMobile = () => matchMedia('(max-width: 767px)').matches;
    
    onFind('.js-iframe-modifier', function (iframe) {
       let options = getPrefixedDataSet('iframe-modifier-mobile', iframe);

       if(isMobile()){
           Object.assign(iframe.style, options);
       }

    });
}